import type { StudentDto } from '@/global/api/gen/ts/StudentDto';
import { apiUpdateGrades } from '@/modules/students/services/student.service';
import { Chip, Stack, Typography } from '@mui/material';
import React from 'react';
import { LoadingButton } from '@mui/lab';

interface Props {
    studentInfo: StudentDto,
    school_id: number,
}

export function QueueGradesTableElement({studentInfo, school_id}: Props) {
    const {mutate, isPending} = apiUpdateGrades();

    const handleSubmitGrades = () => {
        mutate({
            student_id: studentInfo.id,
            school_id: school_id
        });
    };

    if (studentInfo.queue_grades) {
        return (
            <Stack gap={1}>
                <Typography variant={'subtitle2'}>
                    Неподтвержденные оценки в АИС:
                </Typography>
                <Stack
                    flexDirection={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                >
                    <Typography variant={'subtitle2'}>
                        Устройство и техническое обслуживание:
                    </Typography>
                    <Chip
                        variant={'filled'}
                        color={'primary'}
                        label={studentInfo.queue_grades.maintenance}
                    />
                </Stack>
                <Stack
                    flexDirection={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                >
                    <Typography variant={'subtitle2'}>
                        Правила и основы движения:
                    </Typography>
                    <Chip
                        variant={'filled'}
                        color={'primary'}
                        label={studentInfo.queue_grades.rules}
                    />
                </Stack>
                <Stack
                    flexDirection={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                >
                    <Typography variant={'subtitle2'}>
                        Практическое вождение:
                    </Typography>
                    <Chip
                        variant={'filled'}
                        color={'primary'}
                        label={studentInfo.queue_grades.practice}
                    />
                </Stack>
                <LoadingButton
                    loading={isPending}
                    onClick={handleSubmitGrades}
                    variant={'contained'}
                >
                    Отправить в АИС Автошколу
                </LoadingButton>
            </Stack>
        );
    }

    return (
        <Typography  variant={'subtitle2'}>
            Все оценки подтверждены.
        </Typography>
    );
}